var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range-picker',{ref:'rangeDatePicker_'+_vm.componentId,attrs:{"initRange":_vm.selectedDate,"i18n":"EN"},on:{"selected":_vm.onSelectedDate}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-275c4a92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/DateRangePicker.vue
// module id = null
// module chunks = 